module.exports = __webpack_public_path__ + "assets/instagram-logo.ad25901e.svg";